import React from 'react';
import ReactDOM from 'react-dom';
let modalsCount = 0;
// In the future replace it by https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/popover
export class Modal extends React.PureComponent {
    modalRoot;
    appRoot;
    el;
    constructor(props) {
        super(props);
        this.modalRoot = document.getElementById('modal-root');
        this.appRoot = document.getElementById('root');
        if (this.modalRoot) {
            this.el = document.createElement('div');
        }
        else {
            this.el = null;
            console.error('Any HTML Element #modal-root not found for initializing modal component');
        }
    }
    componentDidMount() {
        this.modalRoot && this.el && this.modalRoot.appendChild(this.el);
        if (this.props.isModal) {
            ++modalsCount;
            // @ts-ignore
            this.appRoot.inert = true;
        }
    }
    componentWillUnmount() {
        this.modalRoot && this.el && this.modalRoot.removeChild(this.el);
        if (this.props.isModal) {
            --modalsCount;
            if (modalsCount === 0) {
                // in case there are more modals open
                // @ts-ignore
                this.appRoot.inert = false;
            }
        }
    }
    render() {
        return this.el && ReactDOM.createPortal(this.props.children, this.el);
    }
}
//# sourceMappingURL=Modal.js.map